import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, StickyNote, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import api, { apiErr } from "@/lib/api";

export default function Notes() {
  const [notes, setNotes] = useState([]);
  const [active, setActive] = useState(null);
  const load = () => api.get("/notes").then((r) => setNotes(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { const { data } = await api.post("/notes", { title: "Nouvelle note", content: "" }); load(); setActive(data); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const save = async () => {
    if (!active) return;
    await api.put(`/notes/${active.id}`, { title: active.title, content: active.content });
    toast.success("Note enregistrée"); load();
  };
  const remove = async (id) => { await api.delete(`/notes/${id}`); setActive(null); load(); };

  return (
    <div className="max-w-5xl mx-auto px-6 py-8 animate-fade-up">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl font-bold text-navy">Notes</h1>
        <Button onClick={create} className="bg-navy text-white hover:bg-navy-800 rounded-full gap-2" data-testid="note-add-btn"><Plus className="h-4 w-4" /> Nouvelle note</Button>
      </div>
      <div className="grid md:grid-cols-3 gap-5 mt-6">
        <div className="space-y-2">
          {notes.map((n) => (
            <button key={n.id} onClick={() => setActive(n)} className={`w-full text-left p-3 rounded-xl border ${active?.id === n.id ? "border-navy bg-white" : "border-[#E5E7EB] bg-white hover:border-navy"}`} data-testid={`note-${n.id}`}>
              <p className="font-medium text-navy truncate">{n.title}</p>
              <p className="text-xs text-muted2 truncate">{n.content || "Vide"}</p>
            </button>
          ))}
          {notes.length === 0 && <div className="text-center py-10 text-muted2"><StickyNote className="h-8 w-8 mx-auto mb-2" />Aucune note.</div>}
        </div>
        <div className="md:col-span-2">
          {active ? (
            <div className="bg-white rounded-2xl border border-[#E5E7EB] p-5">
              <Input value={active.title} onChange={(e) => setActive({ ...active, title: e.target.value })} className="font-serif text-xl font-bold text-navy border-0 px-0 focus-visible:ring-0" data-testid="note-title" />
              <Textarea value={active.content} onChange={(e) => setActive({ ...active, content: e.target.value })} rows={12} className="mt-2 border-[#E5E7EB] resize-none" placeholder="Écrivez vos notes…" data-testid="note-content" />
              <div className="flex gap-2 mt-3">
                <Button onClick={save} className="bg-navy text-white hover:bg-navy-800 rounded-full" data-testid="note-save">Enregistrer</Button>
                <Button onClick={() => remove(active.id)} variant="outline" className="rounded-full text-red-500 border-red-200 gap-1"><Trash2 className="h-4 w-4" /> Supprimer</Button>
              </div>
            </div>
          ) : <div className="bg-white rounded-2xl border border-dashed border-[#E5E7EB] p-16 text-center text-muted2">Sélectionnez ou créez une note.</div>}
        </div>
      </div>
    </div>
  );
}
